/**
 * Warstwa kontaktowa w headerze - modal z danymi kontaktowymi
 */
app.service('topContactInfoModal', function (modal, loading) {
	let $modal;

	function openModal() {
		if ($modal) {
			$modal.open();
		} else {
			modalGenerate();
		}
	}

	function modalGenerate() {
		loading.start();
		$.ajax({
			url: '/helplineInfo.ltr',
			success: function (htmlData) {
				loading.stop();
				$modal = modal.generate({
					id: 'top-contact-info-modal',
					content: htmlData,
				});
			},
			error: function () {
				loading.stop();
				modal.alert('Błąd generowania warstwy z danymi kontaktowymi. Prosimy spróbować ponownie później.');
			}
		})
	}

	function init() {

		$('body').on('click', '#contact-box', function () {
			openModal();
		});
	}
	return {
		init,
	};
});
